import type { ProFormColumnsType } from '@ant-design/pro-components';
import { intermediaryFeesQuestions } from '@pages/ApplicationFormPage/IntermediaryFees/questions';
import type { TypedFormatMessageFn } from '@app-types/intl';
import { IntermediaryFeesEditableTable } from '../CaseSummary/IntermediaryFeesEditableTable';

interface IntermediaryFeesEditableFormSchemaProps {
  formatMessage: TypedFormatMessageFn;
}

export function intermediaryFeesEditableFormSchema(
  props: IntermediaryFeesEditableFormSchemaProps,
): ProFormColumnsType[] {
  return [
    {
      title: props.formatMessage({ id: intermediaryFeesQuestions.hasIntermediaryFees.labelKey }),
      dataIndex: 'hasIntermediaryFees',
      valueType: 'radioButton',
      fieldProps: {
        options: [
          { label: props.formatMessage({ id: 'common.yes' }), value: 'true' },
          { label: props.formatMessage({ id: 'common.no' }), value: 'false' },
        ],
        buttonStyle: 'solid',
      },
    },
    {
      valueType: 'dependency',
      name: ['hasIntermediaryFees'],
      columns: ({ hasIntermediaryFees }) => {
        if (hasIntermediaryFees !== 'true') {
          return [];
        }

        return [
          {
            dataIndex: 'fees',
            renderFormItem: () => <IntermediaryFeesEditableTable />,
          },
        ];
      },
    },
  ];
}
